<template>
  <div id="app" class="home">
    <div class="header"  >
      <div class="banner" :class="{
            'header-banner': isSearch || isUser,
            'header-banner1': isUserinfo,
            'header-banner2': noBanner,
            'header-banner3':isNavSearch
          }" v-if="banner.length != 0">
        <div class="banner-input" @click="search()" v-if="this.$store.state.webCount.base_conf.is_home_search == 1">
          <img class="search-icon" src="/static/images/search-icon.png" />
          <input type="text" placeholder="搜索你想要的" />
        </div>
        <van-swipe
          v-if="this.$store.state.webCount.base_conf.is_banner == 1"
          :autoplay="3000"
          indicator-color="white"
          @change="onChange"
        >
          <van-swipe-item v-for="(item, index) in banner" :key="index">
            <div class="img-d">
              <a @click="bannergo(item.url, item.url_type)">
                <img v-lazy="item.image" />
              </a>
            </div>
          </van-swipe-item>
          <div class="custom-indicator" slot="indicator">
            <span
              :class="current == index ? 'active' : ''"
              v-for="(item, index) in banner"
              :key="item.image"
            ></span>
          </div>
        </van-swipe>
      </div>

      <div class="user-info" :style="{ marginTop: this.$store.state.webCount.base_conf.is_banner == 0 ? 0.2 + 'rem' :  isUserinfo ?-1+'rem':'' }" v-if="(this.$store.state.userCount)&&(this.$store.state.webCount.base_conf.is_user_name == 1||this.$store.state.webCount.base_conf.is_fudou == 1)" >
        <div class="userbox-info">
          <span class="user-name" v-if="this.$store.state.webCount.base_conf.is_user_name == 1">
            {{ name }}
          </span>
          <div class="user-integral" v-if="this.$store.state.webCount.base_conf.is_fudou == 1">
            <img src="/static/images/user-jf.png" alt="" />
            <span>  {{ unit }}:<span
              v-html="
                this.$store.state.userCount.point == null ? '0' : this.$store.state.userCount.point
              "
            ></span></span>


          </div>
        </div>
        <div class="userbox">
          <router-link to="/user/personal" v-if="this.$store.state.webCount.base_conf.is_user_name == 1">
            <img
              v-if="this.$store.state.userCount.image == null"
              :src="
                this.$store.state.userCount.user_icon == null
                  ? '/static/images/userheaderimg.png'
                  : this.$store.state.userCount.user_icon
              "
              onerror="src='/static/images/userheaderimg.png'"
              class="head-portrait"
            />
            <img
              :src="this.$store.state.userCount.image"
              v-if="this.$store.state.userCount.image != null"
              onerror="src='/static/images/userheaderimg.png'"
              class="head-portrait"
            />
          </router-link>
        </div>
      </div>

      <div class="home-tab" :style="{ background:   $store.state.webCount.base_conf.is_banner == 0&&$store.state.webCount.base_conf.is_banner == 0&& ($store.state.webCount.base_conf.is_fudou == 1||$store.state.webCount.base_conf.is_home_search == 1) ? 'none':'' }"   :class="isNavSearch?'home-tab1':isUser?'home-tab2':''" v-if="this.$store.state.webCount.base_conf.is_nav == 1">
        <van-swipe class="my-swipe" indicator-color="#323232" @change="tabCurrent">
          <van-swipe-item>
            <div class="home-tab-c">
              <template v-for="(item, index) in nav">
                <div
                  :key="index"
                  class="tab-item"
                  @click="go(item.url, item.url_type)"
                  v-if="index < 8"
                >
                <img :src="item.image" onerror="src='/static/images/zw.png'" class="home-tab-img" />
                <span>{{ item.name }}</span>
              </div>
              </template>
            </div>
          </van-swipe-item>
          <van-swipe-item v-if="nav.length > 8">
            <div class="home-tab-c">
              <template v-for="(item, index) in nav">
                <div
                  :key="index"
                  class="tab-item"
                  @click="go(item.url, item.url_type)"
                  v-if="index >= 8"
                >
                <img onerror="src='/static/images/zw.png'" class="home-tab-img" />
                <span>{{ item.title }}</span>
              </div>
              </template>
            </div>
          </van-swipe-item>

          <template #indicator>
            <div class="indicator" v-if="nav.length > 8">
              <div
                :class="['custom-indicator', { 'indicator-active': tcurrent + 1 == index }]"
                v-for="index in 2"
                :key="index"
              ></div>
            </div>
          </template>
        </van-swipe>
      </div>

      <div class="message" v-if="mess_list.length != 0">
        <van-notice-bar background="#fff">
          <template #left-icon>
            <div class="messge-icon">
              <!-- <i class="van-icon iconfont icon-gonggao theme-col"></i> -->
              <img src="./../assets/img/gg.png" alt="" />
            </div>
          </template>
          <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
            <van-swipe-item v-for="(items, index) in mess_list" :key="index">
              <p @click="lookNews(items.title, items.message || items.content, items.add_time)">
                {{ items.title }}
              </p>
              <!-- <router-link> -->
              <van-icon name="arrow" color="rgba(38, 38, 38, .3)" />
              <!-- </router-link> -->
            </van-swipe-item>
          </van-swipe>
        </van-notice-bar>
      </div>
    </div>

    <div class="message" v-if="xiaoxi.length != 0">
      <van-notice-bar background="#fff">
        <template #left-icon>
          <div class="messge-icon">
            <img src="./../assets/img/gg.png" alt="" />
          </div>
        </template>
        <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
          <van-swipe-item v-for="(items, index) in xiaoxi" :key="index">
            <p @click="lookNews(items.title, items.content, items.add_time)">{{ items.title }}</p>
            <!-- <router-link> -->
            <van-icon name="arrow" color="rgba(38, 38, 38, .3)" />
            <!-- </router-link> -->
          </van-swipe-item>
        </van-swipe>
      </van-notice-bar>
    </div>

    <!--滚动消息弹框-->
    <van-popup v-model="newshow" class="adven-popup userlist-popup">
      <div class="hintbox">
        <div class="hintclear" @click="closePop">
          <img src="/static/images/adventures-clear.png" />
        </div>
        <h3 class="title">{{ newsTitle }}</h3>
        <p>尊敬的用户：</p>
        <div class="hintcent">您好！{{ newsCont }}</div>
        <p class="text-right">运营中心</p>
        <p style="padding-top: 0.05rem" class="text-right">{{ time(newsTime) }}</p>
        <div class="newclose">
          <van-button size="normal" class="theme-bg" @click="closePop">我知道了</van-button>
        </div>
      </div>
    </van-popup>
<div style="margin-top: 0.14rem"></div>
    <div v-for="(items, index) in zhuanti" :key="index" style="margin-top: 0.2rem"  >
      <div v-if="items.is_image === 0 && items.type == 1">
        <subject1 :zhuanti="items"></subject1>
      </div>
      <div v-if="items.is_image === 1 && items.type == 1">
        <subject0 :zhuanti="items"></subject0>
      </div>
      <div v-if="items.is_image === 2 && items.type == 1">
        <subject2 :zhuanti="items"></subject2>
      </div>
      <div
        class="content"
        v-if="items.type == 2"
        :class="items.imglist_style ? 'content' + items.imglist_style : ''"
      >
        <div class="item" v-for="(items1, index1) in items.imglist" :key="index1">
          <a :href="items1.link ? items1.link : 'javascript:void(0)'">
            <img v-if="items1.file_image.image_url" :src="items1.file_image.image_url" />
          </a>
        </div>
      </div>
    </div>

    <div v-if="bottomShow" class="nomore">
      <div style="margin-bottom: 0.06rem" class="theEnd">——已经到底了——</div>
      <div class="leftIn" v-if="this.$store.state.webCount.service_tell != ''">
        客服电话：
        <span>{{ this.$store.state.webCount.service_tell }}</span>
      </div>
      <div class="leftIn1">
        <span>{{ this.$store.state.webCount.service_tel_remark }}</span>
      </div>
    </div>
        <van-dialog
      class="announcements"
      v-model="corporateAnnouncement"
      :show-confirm-button="false"
      :closeOnClickOverlay="true"
    >
      <template slot="title">
        <div class="announcements-title">
          <van-icon name="cross" @click="corporateAnnouncement = false" />
        </div>
      </template>
      <template v-for="(item, index) in  announcement">
        <span v-if="item.type == 'text'" :key="index">{{ item.text }}</span>
        <img v-if="item.type == 'image'" :src="item.text" :key="index" />
      </template>
    </van-dialog>
    <!--底部导航-->
    <footer-nav></footer-nav>

    <CustomerService></CustomerService>
  </div>
</template>

<script>
import Vue from "vue";
//  import '../assets/css/style.less'
import FooterNav from "@/components/footernav";
import store from "../vuex/store";
import subject0 from "@/components/subject";
import subject1 from "@/components/subject1";
import subject2 from "@/components/subject2";
import CustomerService from "@/components/CustomerService";
import { Swipe, SwipeItem } from "mint-ui";
import { Dialog } from "vant";

Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);

export default {
  name: "detail",
  components: {
    FooterNav,
    subject0,
    subject1,
    subject2,
    [Dialog.Component.name]: Dialog.Component,
    CustomerService
  },
  store,
  data() {
    return {
      //        datas:'',
      datass: [],
      firstban: { img: "", ad_link: "" },
      lastban: { img: "", ad_link: "" },
      search_keywords: "",
      hose: "", //当前域名
      nav: "",
      zhuanti: "",
      banner: "",
      mess_list: "",
      newshow: false,
      newsTitle: "",
      newsCont: "",
      newsTime: "",
      bottomShow: false,
      xiaoxi: "",
      current: 0,
      tcurrent: 0,
      announcement: [],
      corporateAnnouncement: false
    };
  },
  beforeRouteEnter(to, from, next) {
    if (
      from.name == "User" ||
      from.name == "Cart" ||
      from.name == "Goodstype" ||
      from.name == "GoodsList"
    ) {
      window.scrollTo(0, 0);
    }
    next();
  },
  methods: {
    toTabber(item) {
      console.log(item);
      this.$router.push({
        path: "Mall/Product/Product/index"
      });
    },
    search() {
      this.$router.push("/goodsList?id=-1");
    },
    onChange(index) {
      this.current = index;
    },
    tabCurrent(index) {
      this.tcurrent = index;
    },
    subjectType(is_image) {
      if (is_image === 0) {
        return "subject1";
      }
      if (is_image === 1) {
        return "subject0";
      }
      if (is_image === 2) {
        return "subject2";
      }
    },
    go: function(url, type) {
      var BLHuser = localStorage.getItem("BLHuser");
      var totalpoint = localStorage.getItem("total");
      if (type == 0) {
        switch (url) {
          case "Mall/Product/Product/index":
            this.$router.push({ path: "/goodsList", query: { id: -1 } });
            break;
          case "Mall/Member/Member/collect":
            this.$router.push({ path: "/user/collect" });
            break;
          case "Mall/Product/Product/iExchange":
            if (BLHuser != "" && BLHuser != undefined && BLHuser != null) {
              this.$router.push({
                path: "/goodsList",
                query: { max: totalpoint }
              });
            } else {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({ name: "NoteLogin" });
                })
                .catch(() => {});
            }
            break;
          case "Mall/Member/Member/index":
            this.$router.push({ path: "/user" });
            break;
        }
      } else {
        window.location.href = url;
      }
    },
    lookNews(tilte, content, time) {
      this.newsTitle = tilte;
      this.newsCont = content;
      this.newsTime = time;
      this.newshow = true;
    },
    time: function(timestamp) {
      if (timestamp.toString().indexOf("-") > -1) {
        return timestamp;
      }
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D;
    },
    goBack: function() {
      history.back(-1);
    },
    typego(url, type, clas_id) {
      if (type == 1) {
        //外部链接
        var arr = url.split("?");
        var BLHuser = localStorage.getItem("BLHuser");
        var mallid = localStorage.getItem("mallid");
        var code = arr[1].split("=");
        //判断是不是活动系统
        if (arr[0] == "http://www.system.fensaas.com") {
          if (!BLHuser) {
            this.$dialog
              .confirm({
                title: "提示 ",
                message: "您还未登录是否去登录？"
              })
              .then(() => {
                this.$router.push({ name: "NoteLogin" });
              })
              .catch(() => {});
            return false;
          }
          this.$api.get(
            "/movable/auth/member",
            { id_example: mallid, token_user: BLHuser, code: code[1] },
            res => {
              if (res.data.code == 1) {
                window.location.href =
                  res.data.data.web_url + "?token=" + res.data.data.token;
              } else if (res.data.code == 201) {
                this.$dialog
                  .confirm({
                    title: "提示 ",
                    message: "您还未登录是否去登录？"
                  })
                  .then(() => {
                    this.$router.push({ name: "NoteLogin" });
                  })
                  .catch(() => {});
              } else {
                this.$toast(res.data.message);
              }
            }
          );
        } else {
          window.location.href = url;
        }
      } else {
        //内部链接
        this.$router.push({
          path: "/goodsList",
          query: { id: clas_id, stype: 1 }
        });
      }
    },
    bannergo(url, type) {
      if (type == 0) {
        //          var reg='http://'+this.host+'/'
        //          var str = url.replace(reg,"");
        //          this.$router.push({path:str})
        this.$router.push({ path: url });
      } else {
        var arr = url.split("?");
        var BLHuser = localStorage.getItem("BLHuser");
        var mallid = localStorage.getItem("mallid");

        var code;
        if (arr[1]) {
          code = arr[1].split("=");
        }
        //判断是不是活动系统
        if (arr[0] == "http://www.system.fensaas.com") {
          if (!BLHuser) {
            this.$dialog
              .confirm({
                title: "提示 ",
                message: "您还未登录是否去登录？"
              })
              .then(() => {
                this.$router.push({ name: "NoteLogin" });
              })
              .catch(() => {});
            return false;
          }
          this.$api.get(
            "/movable/auth/member",
            { id_example: mallid, token_user: BLHuser, code: code[1] },
            res => {
              if (res.data.code == 1) {
                window.location.href =
                  res.data.data.web_url + "?token=" + res.data.data.token;
              } else if (res.data.code == 201) {
                this.$dialog
                  .confirm({
                    title: "提示 ",
                    message: "您还未登录是否去登录？"
                  })
                  .then(() => {
                    this.$router.push({ name: "NoteLogin" });
                  })
                  .catch(() => {});
              } else {
                this.$toast(res.data.message);
              }
            }
          );
        } else {
          window.location.href = url;
        }
      }
    },
    closePop: function() {
      this.newshow = false;
    },
    getdatas: function() {
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      //轮播图
      this.$api.get(
        "/sys/banner",
        { id_example: mallid, terminal: "wap" },
        res => {
          if (res.data.code == "100") {
            if (
              res.data.data.location_url != undefined &&
              res.data.data.location_url != null
            ) {
              window.location.href = res.data.data.location_url;
              return false;
            }
            this.banner = res.data.data;
          }
        }
      );
      //页面导航
      this.$api.get(
        "/sys/channel",
        { id_example: mallid, terminal: "wap" },
        res => {
          if (res.data.code == "100") {
            if (
              res.data.data.location_url != undefined &&
              res.data.data.location_url != null
            ) {
              window.location.href = res.data.data.location_url;
              return false;
            }
            this.nav = res.data.data;
          }
        }
      );
      //通知
      this.$api.get("/sys/notice", { id_example: mallid }, res => {
        if (res.data.code == "100") {
          if (
            res.data.data.location_url != undefined &&
            res.data.data.location_url != null
          ) {
            window.location.href = res.data.data.location_url;
            return false;
          }
          this.mess_list = res.data.data;
        }
      });
      //专题
      this.$api.get(
        "/sys/subject",
        { id_example: mallid, terminal: "wap" },
        res => {
          if (res.data.code == "100") {
            this.zhuanti = res.data.data;
            console.log(this.zhuanti);
            setTimeout(function() {
              _this.bottomShow = true;
            }, 1000);
          }
        }
      );
      //消息
      this.$api.get(
        "/notice/list",
        { id_example: mallid, terminal: "wap" },
        res => {
          if (res.data.code == "100") {
            // this.xiaoxi = res.data.data
            this.mess_list.push(...res.data.data);
          }
        }
      );
    },
    // 获取企业公告
    getAnnouncement() {
      var mallid = localStorage.getItem("mallid");
      this.$api.get("/sys/getAnnouncement", { id_example: mallid }, res => {
        this.announcement = res.data.data.content;

        if (this.announcement && this.announcement.length > 0) {
          const d = new Date();
          let oldTime = JSON.parse(localStorage.getItem("announcement"));
          if (JSON.parse(localStorage.getItem("announcement"))) {
            if (d.getTime() - oldTime > 24 * 60 * 60 * 1000) {
              this.corporateAnnouncement = true;
              localStorage.setItem("announcement", JSON.stringify(d.getTime()));
            }
          } else {
            this.corporateAnnouncement = true;
            localStorage.setItem("announcement", JSON.stringify(d.getTime()));
          }
        }
      });
    }
  },
  computed: {
    totalPrice() {
      this.getdatas();
      this.$store.commit("userInfo");
      return this.$store.state.webCount;
    },
    name: function() {
      if (this.$store.state.userCount.user_name != "") {
        return this.$store.state.userCount.user_name;
      } else if (this.$store.state.userCount.wechat_name != null) {
        return this.$store.state.userCount.wechat_name;
      } else {
        return this.$store.state.username;
      }
    },
    unit: function() {
      return this.$store.state.unitinfo.name;
    },
    //  只有搜索框存在
    isSearch() {
      return (
        // this.$store.state.webCount.base_conf.is_nav
        this.$store.state.webCount.base_conf.is_home_search == 1 &&
        this.$store.state.webCount.base_conf.is_user_name == 0 &&
        this.$store.state.webCount.base_conf.is_fudou == 0 &&
        this.$store.state.webCount.base_conf.is_banner == 0 &&
        this.$store.state.webCount.base_conf.is_nav == 0
      );
    },
    // 搜索框和用户同时存在
    isUser() {
      return (
        this.$store.state.webCount.base_conf.is_home_search == 1 &&
        (this.$store.state.userCount.user_name &&
          (this.$store.state.webCount.base_conf.is_user_name == 1 ||
            this.$store.state.webCount.base_conf.is_fudou == 1)) &&
        this.$store.state.webCount.base_conf.is_banner == 0 &&
        this.$store.state.webCount.base_conf.is_nav == 0
      );
    },
    // 只有用户信息存在
    isUserinfo() {
      return (
        this.$store.state.webCount.base_conf.is_home_search == 0 &&
        (this.$store.state.webCount.base_conf.is_user_name == 1 ||
          this.$store.state.webCount.base_conf.is_fudou == 1) &&
        this.$store.state.webCount.base_conf.is_banner == 0 &&
        this.$store.state.webCount.base_conf.is_nav == 0
      );
    },
    // 只有banner图没有显示
    noBanner() {
      return (
        this.$store.state.webCount.base_conf.is_home_search == 1 &&
        (this.$store.state.webCount.base_conf.is_user_name == 1 ||
          this.$store.state.webCount.base_conf.is_fudou == 1) &&
        this.$store.state.webCount.base_conf.is_banner == 0 &&
        this.$store.state.webCount.base_conf.is_nav == 1
      );
    },
    // 导航栏和搜索框同时存在
    isNavSearch() {
      return (
        this.$store.state.webCount.base_conf.is_home_search == 1 &&
        this.$store.state.webCount.base_conf.is_nav == 1 &&
        this.$store.state.webCount.base_conf.is_banner == 0 &&
        ((this.$store.state.webCount.base_conf.is_user_name == 0 &&
          this.$store.state.webCount.base_conf.is_fudou == 0) ||
          !this.$store.state.userCount.user_name)
      );
    }
  },
  watch: {
    //vuex实现方式1
    totalPrice: {
      handler: function(val, oldval) {}
    }
  },
  mounted() {
    this.host = window.location.host;
  },
  activated() {
    this.getAnnouncement();
  }
};
</script>

<style lang="less">
.home {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #f5f5f5;
  padding-bottom: 1rem;

  .header {
    background-image: url("./../assets/img/home-pg.png");
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .banner {
    width: 100%;
    position: relative;
    margin: 0 auto;
    .banner-input {
      position: absolute;
      width: 6.9rem;
      left: 50%;
      margin-left: -3.45rem;
      height: 0.68rem;
      background: rgba(255, 255, 255, 0.7);
      border-radius: 0.32rem;
      backdrop-filter: blur(5px);
      overflow: hidden;
      margin-top: 0.1rem;
      z-index: 1;
      .search-icon {
        width: 0.32rem;
        height: 0.32rem;
        position: absolute;
        left: 0.3rem;
        top: 0.16rem;
      }
      input {
        width: 100%;
        border: none;
        background: no-repeat;
        height: 100%;
        box-sizing: border-box;
        padding-left: 0.84rem;
      }
    }
    .van-swipe {
      height: 3.6rem;
      .van-swipe-item {
        width: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        overflow: hidden;
        .img-d {
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .custom-indicator {
        height: 0.12rem;
        position: absolute;
        bottom: 0.1rem;
        right: 0.2rem;
        bottom: 0.4rem;
        display: flex;

        .active {
          width: 0.36rem;
          border-radius: 0.2rem;
          background: white;
        }
        span {
          margin: 0 0.02rem;
          display: inline-block;
          width: 0.12rem;
          height: 100%;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.4);
          transition: width 0.2s ease;
        }
      }
    }
  }
  .header-banner {
    background: url(/static/images/header-bg.png) no-repeat center;
    background-size: cover;
    min-height: 1.08rem;
  }
  .header-banner1 {
    background: url(/static/images/header-bg.png) no-repeat center;
    background-size: cover;
    margin-top: -0.8rem;
    min-height: 1.92rem;
  }
  .header-banner2 {
    background: url(/static/images/header-bg.png) no-repeat center;
    background-size: cover;
    min-height: 1.4rem;
  }
  .header-banner3 {
    background: url(/static/images/header-bg.png) no-repeat center;
    background-size: cover;
    min-height: 0.8rem;
  }
  .user-info {
    width: 7.1rem;
    height: 1.28rem;
    background: url("/static/images/userinfo-bg.png") no-repeat center;
    background-size: 100% 100%;
    border-radius: 0.16rem;
    padding: 0 0.3rem;
    box-sizing: border-box;
    position: relative;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -0.3rem;
    .userbox-info {
      display: flex;
      margin-top: -0.2rem;
      .user-name {
        font-size: 0.32rem;
        font-weight: 500;
        color: #262626;
        line-height: 0.44rem;
        margin-right: 0.14rem;
      }

      .user-integral {
        height: 0.36rem;
        background: linear-gradient(270deg, #e7c3a0 0%, #fde9de 100%);
        border-radius: 0.16rem;
        padding: 0 0.2rem 0 0.5rem;
        font-size: 0.26rem;
        font-weight: 400;
        color: #9e672e;
        line-height: 0.4rem;
        position: relative;
        margin-top: 0.05rem;

        img {
          width: 0.44rem;
          height: 0.44rem;
          position: absolute;
          left: -0.02rem;
          top: -0.05rem;
        }

        span {
          font-size: 0.26rem;
          font-weight: 400;
          color: #9e672e;
          line-height: 0.36rem;
        }
      }
    }
    .userbox {
      display: flex;
      align-items: center;
      margin-top: -0.14rem;

      .head-portrait {
        width: 0.64rem;
        height: 0.64rem;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }
  .home-tab {
    width: 100%;
    background-color: #fff;
    padding: 0 0 0.2rem 0;
    // border-top-left-radius: 0.3rem;
    // border-top-right-radius: 0.3rem;
    position: relative;
    margin-top: 0.12rem;
    &.home-tab1 {
      padding-top: 0.2rem;
    }
    &.home-tab2 {
      background: none !important;
    }

    .home-tab-c {
      display: flex;
      flex-wrap: wrap;
    }

    .tab-item {
      flex-basis: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 0.2rem;
      // justify-content: center;

      .home-tab-img {
        // width: 1.64rem;
        // height: auto;
        width: auto;
        height: 0.9rem;
      }

      span {
        display: inline-block;
        box-sizing: border-box;
        padding: 0 0.1rem;
        font-size: 0.24rem;
        margin-top: 0.13rem;
        text-align: center;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }

    .indicator {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;

      .custom-indicator {
        width: 0.06rem;
        height: 0.06rem;
        background: rgba(170, 170, 170, 0.5);
        border-radius: 50%;
        margin-right: 0.1rem;
      }

      .indicator-active {
        width: 0.1rem;
        height: 0.06rem;
        background: #fc8c10;
        border-radius: 0.05rem;
      }
    }
  }

  .message {
    width: 100%;
    height: 0.8rem;
    background: #ffffff;
    border: 0.02rem solid #f2f2f2;

    .van-notice-bar__content {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;

      .messge-icon {
        display: flex;
        align-items: center;
        margin-right: 0.18rem;

        img {
          width: 0.86rem;
          height: auto;
        }
      }
      .notice-swipe {
        width: 100%;
        height: 100%;

        .van-swipe-item {
          display: flex;
          align-items: center;
          color: #262626;

          p {
            width: 100%;
          }
        }
      }
    }
  }

  .userlist-popup {
    background-color: inherit;
    width: 80%;
    border-radius: 0.24rem;
    background: #fff;
    overflow: hidden;
    .hintbox {
      position: relative;
      p {
        padding: 0 0.4rem;
        font-size: 0.24rem;
        color: #666;
      }
      .title {
        padding: 0.4rem 0 0.2rem 0;
        border-radius: 0.24rem 0.24rem 0 0;
        text-align: center;
        font-size: 0.32rem;
        background: #fff;
      }
      .hintclear {
        img {
          width: 0.44rem;
          border-radius: 50%;
        }
        position: absolute;
        right: -0.3rem;
        top: -0.6rem;
      }
      .hinttit {
        font-size: 0.18rem;
        text-align: center;
        padding: 0.15rem 0;
      }
      .newclose {
        text-align: center;
        padding: 0.15rem 0 0.2rem 0;
        background: #fff;
        border-radius: 0 0 0.12rem 0.12rem;
        button {
          height: 0.72rem;
          line-height: 0.68rem;
          width: 35%;
          border-radius: 0.12rem;
          font-size: 0.28rem;
          background-color: #fe2b3c;
          color: #fff;
        }
      }
      .hintcent {
        background-color: #fff;
        padding: 0.05rem 0.4rem 0.05rem 0.4rem;
        max-height: 1.8rem;
        overflow-y: auto;
        color: #666;
        font-size: 0.26rem;
        .van-button {
          height: 0.4rem;
          padding: 0 0.4rem;
          border-radius: 0.2rem;
          margin-top: 0.2rem;
          font-size: 0.16rem;
          background: #fe2b3c;
          border: none;
          color: #fff !important;
          box-shadow: 0rem 0.04rem 0.3rem #fe2b3c;
        }
      }
    }
    .userlist {
      padding: 0.035rem 0.3rem;
    }
  }
  .content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    // width: calc(100% - 0.4rem);
    margin: 0 auto;

    .item {
      width: 100%;
      height: 2rem;
      // background-color: #fff;

      background-repeat: no-repeat;
      background-position: center;
      // border-radius: 8px;
      position: relative;
      // border: 1px solid #d6dee9;
      p {
        border: 0px;
        width: 100%;
        bottom: 10px;
        position: absolute;
        bottom: 10px;
        text-align: center;
      }
      img {
        width: 100%;
        height: 100%;
        display: inline-block !important;
      }
    }

    &.content1 {
      .item {
        width: 100%;
        // margin: 0px 2px;
      }
    }
    &.content2 {
      flex-wrap: nowrap;
    }
    &.content3 {
      flex-wrap: wrap;
    }
    &.content4 {
      flex-wrap: nowrap;
    }
    &.content5 {
      flex-wrap: wrap;
      .item {
        width: 50%;
        // margin: 2px 0px;
        &:last-child {
          width: 100%;
          margin-top: 2px;
        }
      }
    }
    &.content6 {
      flex-wrap: wrap;
      .item {
        width: 50%;
        // margin: 2px 0px;
        &:first-child {
          width: 100%;
          // margin-bottom: 2px;
        }
      }
    }
    &.content7 {
      flex-wrap: nowrap;
      .item {
        width: 25%;
        // margin: 2px 0px;
      }
    }
    &.content8 {
      flex-wrap: wrap;
      .item {
        width: 33.33%;
        // margin: 2px 0px;
        &:last-child {
          width: 100%;
          // margin-top: 2px;
        }
      }
    }
    &.content9 {
      flex-wrap: wrap;
      .item {
        width: 33.33%;
        // margin: 2px 0px;
        &:first-child {
          width: 100%;
          // margin-bottom: 2px;
        }
      }
    }
    &.content10 {
      flex-wrap: wrap;
      .item {
        width: 50%;
        // margin: 2px 0px;
        &:last-child {
          width: 100%;
          // margin-top: 2px;
        }
        &:nth-child(3) {
          width: 100%;
          // margin-top: 2px;
        }
      }
    }
    &.content11 {
      flex-wrap: wrap;
      .item {
        width: 50%;
        // margin: 2px 0px;
        &:last-child {
          width: 100%;
          // margin-top: 2px;
        }
        &:first-child {
          width: 100%;
          // margin-bottom: 2px;
        }
      }
    }
    &.content12 {
      flex-wrap: wrap;
      .item {
        width: 25%;
        // margin: 2px 0px;
        &:last-child {
          width: 100%;
          // margin-top: 2px;
        }
      }
    }
  }

  .announcements {
    .van-dialog__header {
      height: 0.6rem !important;
      background-color: #fff;
      border-bottom: 1px solid #f2f2f2;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .announcements-title {
        padding-right: 0.2rem;
        font-size: 0.38rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: #878787;
      }
    }
    .van-dialog__content {
      height: 45vh;
      overflow: hidden scroll;
      box-sizing: border-box;
      padding: 0.3rem;
      display: flex;
      flex-direction: column;

      &::-webkit-scrollbar {
        display: none;
      }

      span {
        font-size: 0.28rem;
        font-weight: 400;
        color: #5e5e5e;
        line-height: 0.46rem;
      }

      img {
        max-width: 100%;
        // max-height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue